import { Component, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class AboutModalContext {
  public data?: any;
}

@Component({
  selector: 'app-about-modal',
  templateUrl: './about-modal.component.html',
  styleUrls: ['./about-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AboutModalComponent implements OnInit {
  @Input() context!: AboutModalContext;
  public country: string | null = null;
  public branchName: string | null = null;
  public division: string | null = null;
  public environmentName: string | null = null;
  public deployedAt: string | null = null;

  constructor(public bsModalRef: BsModalRef<AboutModalContext>) { }

  ngOnInit(): void {
    const data = this.context && this.context.data;
    this.country = data && data.country;
    this.branchName = data && data.branchName;
    this.division = data && data.division;
    this.environmentName = data && data.environmentName;
    this.deployedAt = data && data.deployedAt;
  }

  public closeModalWindow() {
    this.bsModalRef.hide();
  }
}
